<template>
  <div>
    <div :id="this.$data.data.id">
      <div v-for="(item, index) in this.dataParent" :key="index" style="float:left;">
        <ejs-chiplist id="chip-avatar" enableDelete="true" ref="sendData">
          <e-chips>
            <e-chip :text="item" cssClass="e-danger"></e-chip>
          </e-chips>
        </ejs-chiplist>
      </div>

      <div v-for="(item, index) in this.dataSource" :key="index" style="float:left;">
        <ejs-chiplist id="chip-avatars-s" enableDelete="true">
          <e-chips>
            <e-chip :text="item" cssClass="e-danger"></e-chip>
          </e-chips>
        </ejs-chiplist>
      </div>
    </div>
    <div style="clear:both"></div>
    <!-- input框 -->
    <div :id='this.$data.data.id+"2"' style="display:none">
      <input
        v-model="news"
        class="e-input e-input-group"
        @blur="blurFunc"
        maxlength="20"
        @keyup.enter="keydownFunc"
      />
    </div>

    <!-- 加号 -->
    <div
      :id='this.$data.data.id+",0"'
      class="icon hero-icon hero-icon-add-small"
      @click="addTaints"
      style="color:#dc3545; border:1px dashed rgba(220, 53, 69,0.5);border-radius:6px;"
    ></div>
  </div>
</template>

<script>
import Vue from "vue";
import { ChipListPlugin } from "@syncfusion/ej2-vue-buttons";
import { EventBus } from "../../../plugins/eventBus";

Vue.use(ChipListPlugin);

export default Vue.extend({
  mounted() {
    const dataParentaram = JSON.parse(JSON.stringify(this.$data)).data;
    if (undefined !== dataParentaram.taints && "" !== dataParentaram.taints) {
      this.dataParent = dataParentaram.taints.split(";");
      console.log("dataParent", this.dataParent);
    }
  },
  data: function() {
    return {
      news: "",
      dataSource: [],
      dataParent: [],
      id: "",
      flag: false
    };
  },
  methods: {
    keydownFunc(clickEvent) {
      console.log("clickEvent", clickEvent);
      if (clickEvent.keyCode === 13) {
        this.flag = true;
        this.commonBlurFunc(clickEvent);
      }
    },
    addTaints(args) {
      console.log("args", args);
      const newAddContent = document.getElementById(args.target.id); //加号ID
      this.id = args.target.id.split(",")[0];
      newAddContent.style.display = "none";
      document.getElementById(this.id + "2").style.display = "block";
    },
    commonBlurFunc(args) {
      let pushFlag = true;
      console.log("dataSource", this.dataSource);
      if ("" !== this.news) {
        //校验文本只能数字和字母
        if (!/^[A-Za-z0-9]+$/.test(args.target.value)) {
          EventBus.$emit("toast", {
            type: "warning",
            content: "只能数字和字母"
          });
          return false;
        }

        console.log("dataParent", this.dataParent);
        if (pushFlag) {
          this.dataSource.push(this.news);
        }
      }
      const newAddContent1 = document.getElementById(args.path[1].id);
      newAddContent1.style.display = "none"; //input隐藏
      document.getElementById(this.id + ",0").style.display = "block"; //加号显示
      this.$forceUpdate();
    },

    blurFunc(args) {
      console.log("args blurFunc", args);
      if (!this.flag) {//回车触发失去焦点事件，只要一个即可
        this.commonBlurFunc(args);
      }
      this.flag = false;
    }
  },
  created() {}
});
</script>

<style>
.sample-padding {
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@font-face {
  font-family: "e-chips-icons";
  font-weight: normal;
  font-style: normal;
}
</style>